import {EDITOR_CONTEXT_MENU_ITEM_KEYS} from "../constants/OtherKeys.jsx";
import {GRANTS} from "../constants/PrivilegeTypes.jsx";
import {showShareUrlOptions, openAgendaView, showUnlinkRelatedEntityPrompt} from "./utils.jsx";
import { EDITOR_KEYS } from "../constants/EditorKeys.jsx";
import {handleOnRecordDelete} from "./gridCellMenuUtils.jsx";
import { getIsArchivedForBoard } from "./otherUtils.jsx";
import { getSavedBoardSelection } from "../../react/hooks/useBoards.jsx";

export const editorContextMenuConfig = {
  type: "button",
  menuIcon: null,
  icon: "fa-ellipsis-v fa",
  cls: "b-widget b-tool b-icon",
  style: "background: transparent",
  menu: {
    type: "menu",
    cls: "b-transparent b-widget b-menu b-chrome",
    items: {
      [EDITOR_CONTEXT_MENU_ITEM_KEYS.viewAgendaItem]: {
        type: "menuitem",
        text: "View Agenda",
        icon: "fa-bars fa",
        disabled: true,
        hidden: true,
      },
      [EDITOR_CONTEXT_MENU_ITEM_KEYS.archiveItem]: {
        icon: "fa-solid fa-folder-open",
        text: "Archive",
        disabled: true,
        hidden: true,
      },
      [EDITOR_CONTEXT_MENU_ITEM_KEYS.deleteItem]: {
        text: "Delete",
        icon: "fa fa-trash",
        disabled: true,
        hidden: true,
      },
      [EDITOR_CONTEXT_MENU_ITEM_KEYS.shareItem]: {
        text: "Share",
        icon: "fa fa-copy",
        disabled: true,
        hidden: true,
      },
      [EDITOR_CONTEXT_MENU_ITEM_KEYS.copyItem]: {
        text: "Copy to",
        icon: "fa fa-copy",
        disabled: true,
        hidden: true,
      }
    }
  }
}

export const handleDeleteContextMenuItem = (widgetMap, context, record, configOptions) => {
  widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.deleteItem].hidden = true;
  if (!record.isPhantom && context.user && context.user.can(GRANTS.grant_three)) {
    if (record.archived) {
      widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.deleteItem].hidden = false;
      widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.deleteItem].disabled = false;
      widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.deleteItem].onItem = handleOnRecordDelete([record], configOptions.recordStore, true, () => {
        if (!configOptions.ths.removeListenerAttached) {
          configOptions.ths.removeListenerAttached = configOptions.recordStore.on({
            remove() {
              this.hide();
            },
            once: true,
            thisObj: configOptions.ths
          });
        }
      })
    } else {
      widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.viewAgendaItem].hidden = true;
    }
  }
}

export const handleShareContextMenuItem = (widgetMap, context, record, configOptions) => {
  if (!record.isPhantom && context.user) {
    widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.shareItem].disabled = false;
    widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.shareItem].onItem = () => {
      const editorParams = configOptions.items[EDITOR_CONTEXT_MENU_ITEM_KEYS.shareItem].editorParams();
      showShareUrlOptions(editorParams.message);
    }
  }
}

export const handleArchiveContextMenuItem = (widgetMap, context, record, configOptions) => {
  if (!record.isPhantom && context.user) {
    if (context.user.can(GRANTS.grant_three)) {
      widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.archiveItem].disabled = false;
      widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.archiveItem].onItem = () => {
        if (!record.archived && record.swivuUnlinkPromptConfig) {
          showUnlinkRelatedEntityPrompt(record.swivuUnlinkPromptConfig).then((isArchived) => {
            if (isArchived) {
              handleDeleteContextMenuItem(widgetMap, context, record, configOptions);
              configOptions.ths.hide();
            }
          });
        } else {
          record.archived = !record.archived
          handleDeleteContextMenuItem(widgetMap, context, record, configOptions);
          configOptions.ths.hide();
        };
      };
    }
    widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.archiveItem].text = record.archived ? "Unarchive": "Archive";
  }
}

export const handleViewAgendaContextMenuItem = (widgetMap, context, record, _configOptions) => {
  if (!record.isPhantom && context.user) {
    widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.viewAgendaItem].disabled = false;
    widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.viewAgendaItem].onItem = () => {
      openAgendaView();
    };
  }
}

export const handleCopyContextMenuItem = (widgetMap, context, record, configOptions) => {
  if (!record.isPhantom && context.user && context.user.can(GRANTS.grant_four)) {
    widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.copyItem].disabled = false;
    widgetMap[EDITOR_CONTEXT_MENU_ITEM_KEYS.copyItem].onItem = () => {
      const { recordType } = configOptions.items[EDITOR_CONTEXT_MENU_ITEM_KEYS.copyItem];
      context.editorHandler.openEditor(EDITOR_KEYS.taskCopyMenuEditor, null, {entity: record, entityType: recordType}, { useExisting: true, by: "recordType" });
    }
  }
}

export const canCopyRecord = (isEnabled, selectedBoard, boardStore) => (
  isEnabled && boardStore.records.some(board => (
    board.id !== selectedBoard.id && board.grants?.includes(GRANTS.grant_four)
  ))
)

export const updateTabTitleWithRecordCount = (tabInstance, store) => {
  const { tab } = tabInstance;

  const updateCount = () => {
    const isDisplayingArchivedRecords = getIsArchivedForBoard(getSavedBoardSelection().slug);
    const count = store.allRecords.filter((record) => (
      (isDisplayingArchivedRecords || !record.archived) &&
      !(record.isGroupHeader || record.isLinked)
    )).length;
    if (count) {
      tab.element?.setAttribute("data-store-count", `${count}`);
    } else {
      tab.element?.removeAttribute("data-store-count");
    }
  };

  tabInstance.swivuUpdateCount = updateCount;
  updateCount();
  return store.on("change", updateCount);
};
